import * as BECaller from '../../util/apiCaller';
import { setError } from '../App/ErrorsActions';

// Export Constants
export const SSO_LOADING = 'SSO_LOADING',
  SSO_DATA = 'SSO_DATA';

export function error(err) {
  return setError(err);
}

export function handleError(err) {
  return setError(err, { log: false });
}

export function successSso(data) {
  return {
    type: SSO_DATA,
    payload: {
      loaded: true,
      data
    }
  };
}

export function getSso() {
  return (dispatch) => {
    dispatch({ type: SSO_LOADING, payload: true });
    BECaller.api('sso/config', 'get').then(
      (data) => {
        dispatch(successSso(data))
      },
      (err) => {
        dispatch(handleError(err))
      }
    )
  };
}

export function setSso(data) {
  return (dispatch) => {
    dispatch({ type: SSO_LOADING, payload: true });
    BECaller.api('sso/config', 'post', data).then(
      (data) => {
        dispatch(successSso(data))
      },
      (err) => {
        dispatch(handleError(err))
      }
    )
  };
}

export function fetchSso(url) {
  return (dispatch) => {
    dispatch({ type: SSO_LOADING, payload: true });
    BECaller.api('sso/fetch', 'post', { url }).then(
      (data) => {
        dispatch(successSso(data))
      },
      (err) => {
        dispatch(handleError(err))
      }
    )
  };
}

